import styled from 'styled-components';

export default styled.div`
  flex: 0 0 auto;
  display: inline-block;
  text-align: center;
`;
